import type { Role } from '../types';

export const ROLE_PRIORITY: Record<string, number> = {
  employee:       1,
  line_manager:   2,
  it_staff:       3,
  top_management: 4,
  it_manager:     5,
  admin:          6,
};

export function hasRole(
  user: { role: string; roles?: string[] } | null | undefined,
  roleName: string,
): boolean {
  if (!user) return false;
  if (user.role === 'admin') return true;
  const allRoles = user.roles ?? [user.role];
  return allRoles.includes(roleName);
}

export function getUserRoles(
  user: { role: string; roles?: string[]; userRoles?: { role: string }[] } | null | undefined,
): string[] {
  if (!user) return [];
  if (user.roles) return user.roles;
  if (user.userRoles) return user.userRoles.map(r => r.role);
  return [user.role || 'employee'];
}

export function primaryRole(roles: string[]): Role {
  if (roles.length === 0) return 'employee';
  return roles.reduce((best, r) =>
    (ROLE_PRIORITY[r] ?? 0) > (ROLE_PRIORITY[best] ?? 0) ? r : best,
  roles[0]) as Role;
}
